import Swal from 'sweetalert2';
export const responses = {
    throwErr(err,title = `An Error Occurred`){
        return Swal.fire({
            title: title,
            icon: `error`,
            html : `<pre>${err}</pre>`,
            showCloseButton : true,
        })
    },


}
